export default __webpack_public_path__ + "static/media/Ai.682b5138.svg";